/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shader-form.vue?vue&type=template&id=31eb9e79&"
import script from "./shader-form.vue?vue&type=script&lang=ts&"
export * from "./shader-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports